import React from 'react'
import { Link } from 'react-router-dom'
import { HiHome } from 'react-icons/hi2'

const HubLogo: React.FC = () => (
  <Link
    to="/"
    aria-label="Duo Hub home"
    className="flex h-8 items-center gap-1 rounded-md px-1 text-xl tracking-tighter outline-none transition-colors hover:bg-orange-50 focus-visible:ring-2 focus-visible:ring-orange-500/40"
    style={{
      fontFamily: "'Avenir Next', system-ui, sans-serif",
      fontWeight: 700,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      textRendering: 'optimizeLegibility',
    }}
  >
    <HiHome className="h-[17px] w-[17px] shrink-0 text-[#ff6600]" aria-hidden />
    <span className="flex items-baseline">
      <span className="text-[#ff6600]">duo</span>
      <span className="text-gray-800">hub</span>
    </span>
  </Link>
)

export default HubLogo
